import { render, staticRenderFns } from "./OrderItemCard.vue?vue&type=template&id=0403c5d6&scoped=true&"
import script from "./OrderItemCard.vue?vue&type=script&lang=ts&"
export * from "./OrderItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderItemCard.vue?vue&type=style&index=0&id=0403c5d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403c5d6",
  null
  
)

export default component.exports